import { signInMachine } from './sign-in';
import { createActorContextWithUseActor } from '../../utils/xstate/createActorContextWithUseActor';

/**
 * Determines whether the user came from our Direct Signup Page
 *
 * "Direct" signup is an alternative signup method that allows users to signup with minimal information.
 */
const clientIsFromDirectSignup = () => {
  return new URLSearchParams(window.location.search).get('direct_signup') === 'true';
};
export const SignInMachineContext = createActorContextWithUseActor(signInMachine, {
  input: {
    isWafEnabled: false,
    // overridden in Login page
    isDirectSignupClient: typeof window !== 'undefined' && clientIsFromDirectSignup()
  }
});